import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataStateChangeEvent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { State, process } from '@progress/kendo-data-query';
import { GridSettings } from '../../../../core/common';
import { IGetOrderShipmentDetailsBody, IOrderInquiry, IOrderInquiryDetailsLbl, ITrackShipment, IFreightOrder, FreightOrder, ICustomer, Customer, FreightClaimHeader, FreightClaimDetails, FreightClaimItem, ClaimDoc, ClaimComment } from '../../../../core/models';
import { CommonService } from '../../../../core/services/common.service';
import { LanguageTranslationService } from '../../../../core/services/language-translation.service';
import { OrderService } from '../../../../core/services/order.service';
import { UserService } from '../../../../core/services/user.service';
import { FreightClaimService } from '../../../../core/services/freight-claim.service';
import { FileInfo, FileRestrictions, SuccessEvent } from '@progress/kendo-angular-upload';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { NotifyType } from '../../../../core/enums/NotifyType';

@Component({
  selector: 'app-raise-claim',
  templateUrl: './raise-claim.component.html',
  styleUrls: ['./raise-claim.component.scss']
})
export class RaiseClaimComponent implements OnInit {

  trackShipmentTabGridData: GridDataResult;
  trackShipmentLoading: boolean = false;
  loadingPDF: boolean;
  loadingExcel: boolean;
  public trackShipmentGridData: ITrackShipment[] = [];

  uploadSaveUrl = "";// "http://noatdc-bcswb912:1082/api/FreightClaim/UploadFile";
  uploadRemoveUrl = "";// "http://noatdc-bcswb912:1082/api/FreightClaim/RemoveFile";


  //uploadSaveUrl = "https://localhost:5001/api/FreightClaim/UploadFile";
  //uploadRemoveUrl = "https://localhost:5001/api/FreightClaim/RemoveFile";

  order: IFreightOrder;
  claimTypeDdlData: { name: string, value: string }[] = [];
  selectedLinesForClaim: any = [];
  fullCustomerName: string = '';
  fullShipToAddress: string = '';
  shipToAddress: ICustomer;
  claimComment: string = '';

  isClaimTypeInvalid: boolean = true;
  isSubmitClicked: boolean = false;
  isClaimItemSelected: boolean = true;
  isItemDamagePhotoUploaded: boolean = true;
  isInspectionPhotoUploaded: boolean = true;
  selectedClaimType: any;
  claimConfNum: string = '';
  claimSubmissionInProgress: boolean = false;

  requestTypeDdlData: { name: string, value: string }[] = [];
  selectedRequestType: any;
  isRequestTypeValid: any;
  otherRequestTypeComment: any;
  isOtherRequestCommentValid: any;

  maxFileSizeInMB = 10;
  fileRestrictionText = '';


  constructor(private orderService: OrderService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private userService: UserService,
    //public persistingService: StatePersistingService,
    private languageTranslationService: LanguageTranslationService,
    private cp: CurrencyPipe,
    private appNotify: AppNotifyService,
    private freightClaimService: FreightClaimService) {
    this.uploadSaveUrl = this.freightClaimService.apiBaseUrl() + '/FreightClaim/UploadFile';
    this.uploadRemoveUrl = this.freightClaimService.apiBaseUrl() + '/FreightClaim/RemoveFile';
  }

  ngOnInit() {
    this.isSubmitClicked = false;
    this.requestTypeDdlData = [];
    this.claimSubmissionInProgress = false;
    this.fileRestrictionText = this.fileRestrictions.allowedExtensions.join(" ");
    console.log(this.fileRestrictionText);
    this.shipToAddress = new Customer();
    this.order = this.freightClaimService.selectedOrder;
    let curUser = this.freightClaimService.readUserObject;
    if (curUser) {
      this.fullCustomerName = curUser.customerNumber + '-' + curUser.customerName;
    }
    if (!this.order) {
      this.router.navigate(['/self-service/order-selection']);
    }
    this.loadClaimMasterData();
    this.loadAddressDetails(this.order.shipTo);
    this.selectedLinesForClaim = [];
    this.loadTrackShipmentTabGrid();
  }
  public loadClaimMasterData() {
    this.freightClaimService.loadClaimMasterData().subscribe((response: Array<any>) => {
      if (response) {
        response.forEach((el) => {
          if (el.type == 'ClaimType') {
            this.claimTypeDdlData.push({ name: el.name, value: el.id });
          }
          else if (el.type == 'RequestType') {
            this.requestTypeDdlData.push({ name: el.name, value: el.id });
          }
        })
      }
    }, error => { })
  }
  public loadAddressDetails(id) {
    this.orderService.getAddress(id as number).subscribe((response: ICustomer) => {
      this.shipToAddress = response;
      this.fullShipToAddress = this.shipToAddress.addressLine1 + ',' + this.shipToAddress.city + ',' + this.shipToAddress.state + ',' + this.shipToAddress.zipCode

    });
  }

  public loadTrackShipmentTabGrid(): void {
    const body = {
      orderNumber: this.order.orderNumber.toString(), 
      orderBu: this.order.orderBu
    }
    this.trackShipmentLoading = true;
    this.orderService.getOrderShipmentDetail(body as IGetOrderShipmentDetailsBody).subscribe((response: Array<any>) => {

      this.trackShipmentLoading = false;
      if (response) {
        this.trackShipmentGridData = response.map((obj) => {
          obj.shipDateUIString = new Date(obj.shipDateUIString);
          return obj;
        });
        this.loadTrackShipmentGridData();
      }


    }, error => { this.trackShipmentLoading = false; })
  }


  //#region pagination, sorting,filtering,columnReorder,columnVisibilityChange for shipment grid

  public trackShipmentGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'orderNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };

  public loadTrackShipmentGridData(): void {
    this.trackShipmentTabGridData = process(this.trackShipmentGridData, this.trackShipmentGridstate);
  }

  public trackShipmentGridSortChange(sort): void {
    this.trackShipmentGridstate.sort = sort;
    this.loadTrackShipmentGridData();
  }

  public trackShipmentGridPageChange({ skip, take }: PageChangeEvent): void {
    this.trackShipmentGridstate.skip = skip;
    this.trackShipmentGridstate.take;
    this.loadTrackShipmentGridData();
  }

  public trackShipmentDataStateChange(state: DataStateChangeEvent): void {
    this.trackShipmentGridstate = state;
    this.loadTrackShipmentGridData();
  }

  public onShipmentReorder(e: any): void {   
  }
  public onShipmentVisibilityChange(e: any): void { 
  }

  //#endregion
  //#region label declaration
  public orderDetail = {
    orderHeaderLbl: 'Order Header',
    billingAddressLbl: 'Billing Address',
    shippingAddressLbl: 'Shipping Address',
    soLbl: 'SO #',
    poLbl: 'PO #',
    shippingFromLbl: 'Shipping From',
    jobNumberLbl: 'Job Number',
    cscNameLbl: 'CSC Name',
    cscPhoneLbl: 'CSC Phone',
    OrderDateLbl: 'Order Date',
    orderDetailsLbl: 'Order Details',
    invoiceDetailsLbl: 'Invoice Details',
    trackShipmentLbl: 'Track Shipments',
    exportToPdfLbl: 'Export to PDF',
    exportToExcelLbl: 'Export to Excel',
    lineLbl: 'Line #',
    orderDateLbl: 'Order Date',
    scheduleDateLbl: 'Schedule Date',
    qtyLbl: 'Qty',
    uomLbl: 'UoM',
    itemLbl: 'Item #',
    paintLbl: 'Paint Code',
    listPriceLbl: 'Unit List Price',
    itemDescLbl: 'Item Desc',
    multiplierLbl: 'Multiplier',
    statusLbl: 'Status',
    shipDateLbl: 'Ship Date',
    invoiceNumberLbl: 'Invoice #',
    orderTypeLbl: 'Order Type',
    descriptionLbl: 'Description',
    unitPriceLbl: 'Unit Price',
    extendedPriceLbl: 'Extended Price',
    shipFromLbl: 'Ship From',
    shipmentIdLbl: 'Shipment ID',
    carrierLbl: 'Carrier',
    proNoLbl: 'Pro No.',
    billOfLading: 'Bill Of Lading',
    noOfBoxesLbl: 'No.Of Boxes',
    totalWeightLbl: 'Total Weight',
    totalPriceLbl: 'Total Price',
    grossAmountLbl: 'Gross Amount',
    taxableAmountLbl: 'Taxable Amount',
    invoiceDateLbl: 'Invoice Date',
    openAmountLbl: 'Open Amount',
    taxLbl: 'Tax',
    nonTaxableLbl: 'Non-Taxable Amount',
    kdRefLbl: 'KD Reference Number',
    customerNumberLbl: 'Customer Number',
    relatedInvoiceLbl: 'Related Invoices',
    customerNameLbl: 'Customer Name',
  };

  orderDetailTxt: IOrderInquiryDetailsLbl = {
    orderHeaderLbl: '',
    billingAddressLbl: '',
    shippingAddressLbl: '',
    soLbl: '',
    poLbl: '',
    shippingFromLbl: '',
    jobNumberLbl: '',
    OrderDateLbl: '',
    orderDetailsLbl: '',
    invoiceDetailsLbl: '',
    trackShipmentLbl: '',
    exportToPdfLbl: '',
    exportToExcelLbl: '',
    lineLbl: '',
    orderDateLbl: '',
    scheduleDateLbl: '',
    qtyLbl: '',
    uomLbl: '',
    itemLbl: '',
    paintLbl: '',
    listPriceLbl: '',
    itemDescLbl: '',
    multiplierLbl: '',
    statusLbl: '',
    shipDateLbl: '',
    invoiceNumberLbl: '',
    orderTypeLbl: '',
    descriptionLbl: '',
    unitPriceLbl: '',
    extendedPriceLbl: '',
    shipFromLbl: '',
    shipmentIdLbl: '',
    carrierLbl: '',
    proNoLbl: '',
    billOfLading: '',
    noOfBoxesLbl: '',
    totalWeightLbl: '',
    cscNameLbl: '',
    cscPhoneLbl: '',
    totalPriceLbl: '',
    grossAmountLbl: '',
    taxableAmountLbl: '',
    invoiceDateLbl: '',
    openAmountLbl: '',
    taxLbl: '',
    nonTaxableLbl: '',
    kdRefLbl: '',
    customerNumberLbl: '',
    customerNameLbl: '',
    relatedInvoiceLbl: '',
  }

  public trackShipmentTabGridColumnLbl = {
    shipmentId: 'Shipment ID',
    carrier: 'Carrier',
    proNo: 'Pro No.',
    billOfLoading: 'Bill Of Loading',
    noOfBoxes: 'No. Of Boxes',
    totalWeight: 'Total Weight',
    shipDate: 'Ship Date'
  };
  //#endregion
  //#region Grid Settings 
  public gridShipmentSettings: GridSettings = {
    state: this.trackShipmentGridstate,
    gridData: process(this.trackShipmentGridData, this.trackShipmentGridstate),
    columnsConfig: [{
      field: 'shipmentId',
      title: this.orderDetailTxt.shipmentIdLbl ? this.orderDetailTxt.shipmentIdLbl : this.orderDetail.shipmentIdLbl,
      filterable: true
    },
    {
      field: 'carrier',
      title: this.orderDetailTxt.carrierLbl ? this.orderDetailTxt.carrierLbl : this.orderDetail.carrierLbl,
      filterable: true
    },
    {
      field: 'proNo',
      title: this.orderDetailTxt.proNoLbl ? this.orderDetailTxt.proNoLbl : this.orderDetail.proNoLbl,
      filterable: true
    },
    {
      field: 'billOfLoading',
      title: this.orderDetailTxt.billOfLading ? this.orderDetailTxt.billOfLading : this.orderDetail.billOfLading,
      filterable: true
    },
    {
      field: 'noOfBoxes',
      title: this.orderDetailTxt.noOfBoxesLbl ? this.orderDetailTxt.noOfBoxesLbl : this.orderDetail.noOfBoxesLbl,
      filterable: true
    },
    {
      field: 'totalWeight',
      title: this.orderDetailTxt.totalWeightLbl ? this.orderDetailTxt.totalWeightLbl : this.orderDetail.totalWeightLbl,
      filterable: true
    },
    {
      field: 'shipDateUIString',
      title: this.orderDetailTxt.shipDateLbl ? this.orderDetailTxt.shipDateLbl : this.orderDetail.shipDateLbl,
      _width: 220,
      filter: 'date',
      format: '{0:d}',
      filterable: true
    },
      //{
      //  field: 'qtyToClaim',
      //  title: 'Quantity To Claim',
      //  filterable: false
      //},
    ]
  };
  //#endregion


  //#region Export to PDF and Excel 
  async generateShipmentPDF() {
  }

  generateShipmentExcel() {
  }

  //#endregion

  //#region Btn Click Handle
  onRequestTypeCommentChanged(event) {
    this.validateFormOnInputChange();
  }
  requestTypeSelected(event) {
    this.validateFormOnInputChange();
  }
  claimTypeSelected(event) {
    this.validateFormOnInputChange();
  }
  handleClaimQuantityChange(event, dataItem) {
    let count = event ? event : 0;
    dataItem.claimedQuantity = event;
    if (count > 0) {
      this.selectedLinesForClaim = this.selectedLinesForClaim.filter(x => !(x.shipmentid == dataItem.shipmentid &&
        x.boxno == dataItem.boxno && x.item == dataItem.item && x.itemdescription == dataItem.itemdescription));
      this.selectedLinesForClaim.push(dataItem);
    }
    else if (count == 0) {
      //remove the item from the selection
      this.selectedLinesForClaim = this.selectedLinesForClaim.filter(x => !(x.shipmentid == dataItem.shipmentid &&
        x.boxno == dataItem.boxno && x.item == dataItem.item && x.itemdescription == dataItem.itemdescription));
    }
    this.validateFormOnInputChange();
  }


  submitClaim() {

    if (this.claimSubmissionInProgress) {
      return;
    }
    this.isSubmitClicked = true;
    if (!this.isClaimDetailsValid()) { return; }
    this.claimSubmissionInProgress = true;
    let claim = new FreightClaimHeader();
    claim.jobName = this.order.jobName || '';
    claim.jobNumber = this.order.jobNumber || '';
    claim.shipFrom = this.order.shipFrom || '';
    claim.commentByUser = this.claimComment || '';
    claim.soNumber = +this.order.orderNumber;
    claim.orderType = this.order.orderType || '';
    claim.poNumber = this.order.poNumber || '';
    claim.kdReference = this.order.kdReference || '';
    claim.orderBu = this.order.orderBu;
    claim.orderDate = this.order.orderDateAsDate;
    claim.scheduleDate = this.order.scheduleDateAsDate;
    claim.shipTo = this.fullShipToAddress;
    claim.claimTypeId = this.selectedClaimType.value;
    claim.claimTypeName = this.selectedClaimType.name;
    claim.requestTypeId = this.selectedRequestType.value;
    claim.requestTypeName = this.selectedRequestType.name;

    claim.details = [];
    let claimDetails: FreightClaimDetails;
    let claimedItem: FreightClaimItem;
    this.selectedLinesForClaim.forEach((el, index) => {
      let shipment = this.getParentShipmentDetails(el.shipmentid);
      if (shipment) {
        //check if details already added or not
        let dIndex = claim.details.findIndex(x => x.shipmentId == shipment.shipmentId)
        if (dIndex < 0) {
          claimDetails = new FreightClaimDetails();
          claimDetails.shipmentId = +el.shipmentid;
          claimDetails.carrier = shipment.carrier;// el.carrier;
          claimDetails.proNo = shipment.proNo;
          claimDetails.billOfLading = shipment.billOfLoading;
          claimDetails.noOfBoxes = shipment.noOfBoxes;
          claimDetails.totalWeight = shipment.totalWeight ? shipment.totalWeight.toString() : '';
          claimDetails.shipDate = shipment.shipDateUIString;
          claimDetails.items = [];
          claim.details.push(claimDetails);
        }
        claimedItem = new FreightClaimItem();
        claimedItem.itemNumber = el.item;
        claimedItem.itemDescription = el.itemdescription;
        claimedItem.shipmentId = +el.shipmentid;
        claimedItem.itemWeight = el.itemWeight ? el.itemWeight.toString() : '';
        claimedItem.boxNo = el.boxno
        claimedItem.lineNumber = el.originalLineNumber;
        claimedItem.originalQuantity = el.quantity;
        claimedItem.claimedQuantity = el.claimedQuantity;
        claimDetails.items.push(claimedItem);
      }

    });

    let doc: ClaimDoc;
    claim.carrierInspectionReports = [];
    //probably ...this mapping can be removed
    this.bolDocs.forEach((el, index) => {
      doc = new ClaimDoc();
      doc.fileName = el.fileName;
      doc.uid = el.uid;
      doc.displayOrder = index + 1;
      claim.carrierInspectionReports.push(doc);
    });
    claim.damagedMaterialPhotos = [];
    this.matDamageDocs.forEach((el, index) => {
      doc = new ClaimDoc();
      doc.fileName = el.fileName;
      doc.uid = el.uid;
      doc.displayOrder = index + 1;
      claim.damagedMaterialPhotos.push(doc);
    });

    let c: ClaimComment = new ClaimComment();
    c.commentText = this.claimComment;
    c.commentType = 'C';

    this.freightClaimService.submitClaim(claim).subscribe((response) => {
      //console.log(response);
      this.claimSubmissionInProgress = false;
      this.claimConfNum = response.claimNumber;
      this.orderAcknowledgementDialog.opened = true;
    },
      (error) => {
        this.appNotify.notify(NotifyType.ERROR, "Sorry! An Error Occured! Please try again.");
        this.claimSubmissionInProgress = false;
      }
    );
  }
  //#endregion
  validateFormOnInputChange() {
    if (this.isSubmitClicked) {
      this.isClaimDetailsValid();
    }
    else {
      //no validation check should be there
      let isValid = true;
      this.isClaimTypeInvalid = false;
      this.isClaimItemSelected = true;
      this.isInspectionPhotoUploaded = true;
      this.isItemDamagePhotoUploaded = true;
      this.isRequestTypeValid = true;
    }
  }
  isClaimDetailsValid() {
    let isValid = true;
    this.isClaimTypeInvalid = false;
    this.isClaimItemSelected = true;
    this.isInspectionPhotoUploaded = true;
    this.isItemDamagePhotoUploaded = true;
    this.isRequestTypeValid = true;

    if (!this.selectedClaimType) {
      this.isClaimTypeInvalid = true;
      isValid = false;
    }
    if (!this.selectedLinesForClaim || (this.selectedLinesForClaim && this.selectedLinesForClaim.length == 0)) {
      this.isClaimItemSelected = false;
      isValid = false;
    }

    if (this.uploadedBOLFileNames.length == 0) {
      this.isInspectionPhotoUploaded = false;
      isValid = false;
    }
    if (this.uploadedMatDamageFileNames.length == 0) {
      this.isItemDamagePhotoUploaded = false;
      isValid = false;
    }

    if (!this.selectedRequestType) {
      this.isRequestTypeValid = false;
      isValid = false;
    }

    return isValid;
  }

  getParentShipmentDetails(shipmentId) {
    let shipment = this.trackShipmentGridData.find(x => x.shipmentId == shipmentId);
    return shipment;
  }

  //#region File Upload
  uploadedBOLFileNames: string[] = [];
  bolDocs: ClaimDoc[] = [];
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".jpg", ".png", ".jfif", ".pdf", ".doc", ".docx", ".csv", ".xls", ".xlsx"],
    maxFileSize: this.maxFileSizeInMB * 1000000,
  };
  bolImages: Array<FileInfo> = [];


  bolFileSelected(evt) {
    evt.files.forEach(function (file) {
      if (this.uploadedBOLFileNames.indexOf(file.name) === -1) {
        this.uploadedBOLFileNames.push(file.name);
      }
    }.bind(this));
  }
  bolFileUploadSuccess(evt: SuccessEvent) {  
    if (evt.operation === 'upload') {
      let doc = new ClaimDoc();
      doc.fileName = evt.response.body.originalFileName;
      doc.uid = evt.response.body.newUniqueFileName;
      this.bolDocs.push(doc);
    }
    else if (evt.operation === 'remove') {
      if (evt.files.length > 0) {
        this.uploadedBOLFileNames = this.uploadedBOLFileNames.filter(x => x != evt.files[0].name);
        this.bolDocs = this.bolDocs.filter(x => x.fileName != evt.files[0].name);
      }
    }
  }
  bolFileUploadComplete() {
    this.isInspectionPhotoUploaded = true;
    this.validateFormOnInputChange();
  }

  //#region Material Damage photo upload
  uploadedMatDamageFileNames: string[] = [];
  matDamageDocs: ClaimDoc[] = [];
  damageImages: Array<FileInfo> = [];

  materialDamagePhotoSelected(evt) {
    evt.files.forEach(function (file) {
      if (this.uploadedMatDamageFileNames.indexOf(file.name) === -1) {
        this.uploadedMatDamageFileNames.push(file.name);
      }
    }.bind(this));
    this.validateFormOnInputChange();
  }
  materialDamagePhotoUploadSuccess(evt: SuccessEvent) {
    if (evt.operation === 'upload') {
      let doc = new ClaimDoc();
      doc.fileName = evt.response.body.originalFileName;
      doc.uid = evt.response.body.newUniqueFileName;
      this.matDamageDocs.push(doc);
    }
    else if (evt.operation === 'remove') {
      if (evt.files.length > 0) {
        this.uploadedMatDamageFileNames = this.uploadedBOLFileNames.filter(x => x != evt.files[0].name);
        this.matDamageDocs = this.matDamageDocs.filter(x => x.fileName != evt.files[0].name);
      }
    }
  }
  materialDamagePhotoUploadComplete() {
    this.isItemDamagePhotoUploaded = true;
    this.validateFormOnInputChange();
  }
  //#endregion
  //#endregion

  //#region Claim Conf-->Only For Demo
  public orderAcknowledgementDialog = {
    opened: false,
    acknowledgeNumber: "",
    isError: false
  }

  closeConfirmDialog() {
    this.orderAcknowledgementDialog.opened = false;
    this.router.navigate(['/self-service/order-selection']);
  }
  //#nedregion
}
